import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Heading } from "@cars24/turbo-web/lib/heading";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { bannerEvent } from "./tracking";

const RtoVehInfoBannerList = ({
    cmsImageGallery,
    pageType
}) => {
    const { banners } = cmsImageGallery || {};

    useEffect(() => {
        const bannerTitles = banners && banners.length >= 0 && banners.map(item => item.heading).join(", ");
        sendCustomGaEvents({
            ...bannerEvent,
            eventCategory: bannerTitles,
            eventAction: "shown",
            eventLabel: pageType
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = async (title) => {
        await yieldToMain();
        sendCustomGaEvents({
            ...bannerEvent,
            eventCategory: title,
            eventAction: "clicked_REDIRECT",
            eventLabel: pageType
        });
    };

    return (
        !!(banners || []).length && <div styleName={"styles.exclusiveWrapper"}>
            <Heading level={4} isBold={false}>Curated For You</Heading>
            <div styleName={"styles.exclusiveBanner"}>
                {
                    banners.map((item, index) => (
                        <a href={item.redirectionUrl} key={`rto-cross-sell-${index}`} onClick={() => handleClick(item.heading)}>
                            <LazyImage src={item.desktopImage} alt={item.imageSlug} />
                        </a>
                    ))
                }
            </div>
        </div>
    );
};

RtoVehInfoBannerList.propTypes = {
    cmsImageGallery: PropTypes.object,
    pageType: PropTypes.string
};

export default RtoVehInfoBannerList;
